import React, { Component } from 'react';
import {Table } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { serverIp, toCurrency } from '../../../../config/constants';


class ItemCosts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transactions: [],
        }
    }

    componentDidMount() {
        //console.log("cpx1 ======componentDidMount");
    }

    render() {

        const tableRow = this.props.itemCosts.length > 0
            ? this.props.itemCosts.map((item) =>
                <Table.Row>
                    <Table.Cell> {item.order_num} </Table.Cell>
                    <Table.Cell>{item.item}</Table.Cell>
                    <Table.Cell positive>{toCurrency(item.itemCost)}</Table.Cell>
                    <Table.Cell>{item.inhouse_item}</Table.Cell>
                    <Table.Cell><Link to={'/dashboard/singleOrderView/' + item.order_num} target="_blank">VIEW order</Link></Table.Cell>
                </Table.Row>)
            : ''

        return (<div>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Order #</Table.HeaderCell>
                        <Table.HeaderCell>Item</Table.HeaderCell>
                        <Table.HeaderCell>Item Cost</Table.HeaderCell>
                        <Table.HeaderCell>Inhouse Item</Table.HeaderCell>
                        <Table.HeaderCell>View Order</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {tableRow}
                </Table.Body>

            </Table>
        </div>);
    }
}

export default ItemCosts;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ItemCosts/ItemCosts.js